export const enum DealerMsg {
  DEALER_INFO_TITLE = "Company Information",
  CONTACT_LATHAM = "Contact Latham for Corrections",
  SUB_PATH = "mine/",
  REFRESH = "Refresh Details",
  REFRESH_IN_PROGRESS = "Refreshing Company Details...",
  ERROR_MSG_IMPORT = "Error Importing Company",
  ERROR_MSG_UPDATE = "Error Updating Company",
  SUCCESS_MSG_IMPORT = "Company import successful",
  SUCCESS_MSG_IMPORT_EXISTS = "Note: The Dealer record has been updated.",
  SUCCESS_MSG_UPDATE = "Company refresh successful",
  SUCCESS_TITLE = "Success!",
  ERROR_TITLE = "Something went wrong!",
  UPDATE_DEALER = "Updating dealer profile...",
  SET_DEFAULT_PURCHASE_PARTNER = "Setting default purchase partner...",
}

export const enum EmployeeMsg {
  DELETE_EMPLOYEE = "Deleting employee profile...",
  UPDATE_EMPLOYEE = "Updating employee profile...",
  CREATE_EMPLOYEE = "Creating employee profile...",
  RESET_EMPLOYEE_PASSWORD = "Resetting employee password...",
}
